import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Form, Button, Container, Row, Col, Alert } from 'react-bootstrap'; // Importing react-bootstrap components
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false); // State to track successful login

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Start loading

    try {
      await axios.post('https://genzserver.mylksystems.com/login/Login', {
        username,
        password,
      }).then((response) => {
        console.log('Login response:', response.data);
        sessionStorage.setItem('isLoggedIn', 'true');
        setIsLoading(false);
        setIsLoggedIn(true); // Mark as logged in

      }).catch((error) => {
        console.error('Login error:', error);
        setError('Invalid username or password');
        setIsLoading(false);
      });
    } catch (err) {
      console.error('Error during login:', err);
      setError('Login failed. Please check your credentials and try again.');
      setIsLoading(false);
    }
  };


  useEffect(() => {
    // Check if the user is already logged in
    const loggedIn = sessionStorage.getItem('isLoggedIn') === 'true';
    if (loggedIn) {
      setIsLoggedIn(true);
      window.location.href = '/'; // Redirect to home page if already logged in
    }
  }, [isLoggedIn]);

  return (
    <Container fluid className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
      <Row className="w-100">
        <Col md={6} lg={4} className="mx-auto">
          <div className="login-container p-4 border rounded shadow-lg bg-white">
            <h2 className="text-center mb-4">Login</h2>
            <Form onSubmit={handleSubmit}>
              {/* Username Field */}
              <Form.Group controlId="username" className="mb-3">
                <Form.Label>Username</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </Form.Group>

              {/* Password Field */}
              <Form.Group controlId="password" className="mb-3">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </Form.Group>

              {/* Error Message */}
              {error && <Alert variant="danger" className="mb-3">{error}</Alert>}

              {/* Submit Button */}
              <Button variant="primary" type="submit" block disabled={isLoading}>
                {isLoading ? 'Logging in...' : 'Login'}
              </Button>
            </Form>
          </div>
          
          {/* Conditionally render Link if login is successful */}
          {isLoggedIn && (
            // Hidden Link that triggers navigation when rendered
            <Link to="/" style={{ display: 'none' }} />
          )}
        </Col>
      </Row>
    </Container>
  );
}

export default Login;
